import { render, staticRenderFns } from "./DeliveryService.vue?vue&type=template&id=34aea54c&scoped=true"
import script from "./DeliveryService.vue?vue&type=script&lang=js"
export * from "./DeliveryService.vue?vue&type=script&lang=js"
import style0 from "./DeliveryService.vue?vue&type=style&index=0&id=34aea54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aea54c",
  null
  
)

export default component.exports